import {
	UPDATE_ITRISK,
	CREATE_ITRISK,
	RELATE_ITRISK_ITCONTROL,
	UNRELATE_ITRISK_ITCONTROL,
	DELETE_ITRISK
} from '../actiontypes';
import {API_RESOURCES, createApiCreateAction, createApiDeleteAction, createApiUpdateAction} from '../../util/api';

export const updateItRisk = (engagementId, riskId, data) => {
	return createApiUpdateAction(
		UPDATE_ITRISK,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ITRISK]: riskId
		},
		data,
		undefined,
		{resolve: true}
	);
};

export const createItRisk = (engagementId, data) => {
	return createApiCreateAction(
		CREATE_ITRISK,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ITRISK]: undefined
		},
		data,
		{resolve: true}
	);
};

export const deleteItRisk = (engagementId, itRiskId) => {
	return createApiDeleteAction(
		DELETE_ITRISK,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ITRISK]: itRiskId
		},
		{itRiskId}
	);
};

export function relateItControl(engagementId, itRiskId, itControlId) {
	return createApiCreateAction(
		RELATE_ITRISK_ITCONTROL,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ITRISK]: itRiskId,
			['ItControl']: undefined
		},
		{itControlId},
		{itRiskId, itControlId}
	);
}

export function unRelateItControl(engagementId, itRiskId, itControlId) {
	return createApiDeleteAction(
		UNRELATE_ITRISK_ITCONTROL,
		{
			[API_RESOURCES.ENGAGEMENTS]: engagementId,
			[API_RESOURCES.ITRISK]: itRiskId,
			['ItControl']: itControlId
		},
		{itRiskId, itControlId}
	);
}
